<template>

    <div class="step2content">
    
        <img src="@/assets/images/oxygen-calculator/img-step2-content.png">
        <p class="mt-2">Climbers can inhale Os at different rates. If you consume oxygen at the highest rate, you can use up a bottle fairly quickly. The flow control measures usage in liters per minute.</p>
        
    </div>

</template>


<script>

export default {

    name: 'Step2Content',
    
    data() {
        return {
            componentName: this.$options.name + ' Component'
        }
    },
    
    created() {
        
    },
    
    mounted() {
        
    },
    
    methods: {
        
    }
    
}

</script>


<style lang="scss" scoped>

.step2content {
    color: #4d5384;
    font-size: 15px;
    line-height: 24px;
    font-weight: $font-weight-medium;
    height: 412px;

    @media (min-width: 576px) { // RED (SM)
        height: 433px;
        font-size: 18px;
        line-height: 29px;
    }
    @media (min-width: 768px) { // GREEN (MD)

    }
    @media (min-width: 992px) { // BLUE (LG)

    }
    @media (min-width: 1200px) { // YELLOW (XL)

    }
    @media (min-width: 1400px) { // PURPLE (XXL)

    }

    & img {
        width: 240px;

        @media (min-width: 576px) { // RED (SM)
            width: 280px;
        }
        @media (min-width: 768px) { // GREEN (MD)

        }
        @media (min-width: 992px) { // BLUE (LG)

        }
        @media (min-width: 1200px) { // YELLOW (XL)

        }
        @media (min-width: 1400px) { // PURPLE (XXL)

        }
    }

    & p {
        margin: 0;
        max-width: 600px;
        margin: 0 auto;
    }
}

</style>
